"use client"

import siteMetadata from "@/utils/siteMetaData"
import { Upwork } from "@/lib/icons"

const UpworkBtn = () => {
    return (
        <a
            href={siteMetadata.upwork}
            target="_blank"
            rel="noopener noreferrer"
            className="upwork-btn animate-vibrate"
            aria-label="Hire me on Upwork"
            title="Hire me on Upwork"
        >
            <span style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Upwork className="w-8 h-8 pt-1" />
            </span>
        </a>
    )
}

export default UpworkBtn
